// extracted by mini-css-extract-plugin
export default {"searchInput":"FormComponent_searchInput__Dt0eI","spin":"FormComponent_spin__iecjt"};